import { createAction } from 'redux-actions';

export const IS_LOADING = 'IS_LOADING';
export const UPDATE_BANNER = 'UPDATE BANNER';

const isLoading = createAction(
    IS_LOADING,
    isLoading => isLoading
);

export {
    isLoading
};
